import type { ReactNode, ReactElement } from 'react';

import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
// redux
import { getInitialize } from '../../redux/slices/auth';

export interface JwtProviderProps {
  children?: ReactNode;
  [key: string]: any;
}

// ----------------------------------------------------------------------

export default function JwtProvider({ children }: JwtProviderProps) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getInitialize());
  }, [dispatch]);

  return <>{children}</>;
}
